function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 12c1.934 0 3.5-1.566 3.5-3.5S13.934 5 12 5 8.5 6.566 8.5 8.5 10.066 12 12 12zm0 1.75c-2.336 0-7 1.173-7 3.5V19h14v-1.75c0-2.328-4.664-3.5-7-3.5z",
  fill: "#8781bd"
});

function SvgPersonPurple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    width: 24
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiBoZWlnaHQ9IjI0IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHdpZHRoPSIyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJtMTIgMTJjMS45MzM4IDAgMy41LTEuNTY2MiAzLjUtMy41IDAtMS45MzM3NS0xLjU2NjItMy41LTMuNS0zLjVzLTMuNSAxLjU2NjI1LTMuNSAzLjVjMCAxLjkzMzggMS41NjYyIDMuNSAzLjUgMy41em0wIDEuNzVjLTIuMzM2MjUgMC03IDEuMTcyNS03IDMuNXYxLjc1aDE0di0xLjc1YzAtMi4zMjc1LTQuNjYzNy0zLjUtNy0zLjV6IiBmaWxsPSIjODc4MWJkIi8+PC9zdmc+";
export { SvgPersonPurple as ReactComponent };